import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppService } from "../../core/services/app.service";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { LoadingService } from "./loading.service";

@Injectable({
  providedIn: "root",
})
export class UploadService {
  constructor(
    public http: HttpClient,
    private loadingService: LoadingService
  ) {}

  private getPresignedUrl(folder, fileType): Observable<string> {
    return this.http
      .get<{ url: string }>(
        AppService.getApiUrl() +
          `/presignedURL?folder=${folder}&fileType=${fileType}`
      )
      .pipe(
        switchMap((response: any) => {
          if (!response.Data || !response.Data.presignedURL) {
            throw new Error("Presigned URL not found");
          }
          return [response.Data.presignedURL];
        })
      );
  }

  uploadFileToS3(folder, selectedFile, maxSize = 50): Observable<any> {
    if (!selectedFile || !folder) {
      throw new Error("Invalid params");
    }

    if (selectedFile.size / 1024 / 1024 >= maxSize) {
      throw new Error("The max size upload is " + maxSize + " MB");
    }

    return this.getPresignedUrl(folder, selectedFile.type).pipe(
      switchMap((presignedUrl: string) => {
        return new Observable((observer) => {
          this.loadingService.start();
          fetch(presignedUrl, {
            method: "PUT",
            headers: {
              "Content-Type": selectedFile.type,
            },
            body: selectedFile,
          })
            .then((response) => {
              return presignedUrl.split("?")[0];
            })
            .then((data) => {
              observer.next(data);
              observer.complete();
              this.loadingService.complete();
            })
            .catch((error) => observer.error(error));
        });
      })
    );
  }
}
